// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"6c57475b","667":"af83590a"}[chunkId] + ".chunk.js";
};